export default {"src":"/_next/static/media/Jean.e6e61c96.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};